import { selectRandomElementFromMaxValue } from './tools.js'

function generateRow (dimension, lockedIndexes) {
  const row = Array(dimension).fill('x')
  for (let i = 1; i <= dimension; i++) {
    const occupiedIndexes = row.filter((item, index) => item !== 'x').map(item => row.indexOf(item))
    const forbidenIndexes = Array.from(new Set([...lockedIndexes[i - 1], ...occupiedIndexes]))
    const index = selectRandomElementFromMaxValue(dimension, forbidenIndexes)
    row[index] = i
  }
  if (!row.includes('x')) return row
  return generateRow(dimension, lockedIndexes)
}

function generateGrid (dimension) {
  const grid = []
  const lockedIndexes = Array(dimension).fill([])
  for (var i = 0; i < dimension; i++) {
    const row = generateRow(dimension, lockedIndexes)
    for (let j = 0; j < dimension; j++) {
      lockedIndexes[j] = [...lockedIndexes[j], row.indexOf(j + 1)]
    }
    grid.push(row)
  }
  return grid
}

function generateEmptyGrid (dimension) {
  const grid = []
  for (let i = 0; i < dimension; i++) {
    grid[i] = (Array(dimension).fill('x'))
  }
  return grid
}

function checkNeighbourIndex (grid, rowIndex, columnIndex) {
  if (columnIndex + 1 < grid.length && grid[rowIndex][columnIndex + 1] === 'x') return [rowIndex, columnIndex + 1]
  if (rowIndex + 1 < grid.length && grid[rowIndex + 1][columnIndex] === 'x') return [rowIndex + 1, columnIndex]
  if (columnIndex - 1 > 0 && grid[rowIndex][columnIndex - 1] === 'x') return [rowIndex, columnIndex - 1]
  if (rowIndex - 1 > 0 && grid[rowIndex - 1][columnIndex] === 'x') return [rowIndex - 1, columnIndex]
  return false
}

function resolveGrid (dimension, grid, tetrisGrid) {
  const resolvedGrid = generateEmptyGrid(dimension)

  for (let i = 0; i < tetrisGrid.length; i++) {
    const row = tetrisGrid[i]
    for (let j = 0; j < row.length; j++) {
      if (row[j].size === 1) {
        resolvedGrid[i][j] = row[j].type1
      }
    }
  }

  // essaye de resoudre la grille 5 fois
  let tries = 0
  while (tries < 5) {
    for (let i = 0; i < resolvedGrid.length; i++) {
      const row = resolvedGrid[i]
      for (let j = 0; j < row.length; j++) {
        // si on trouve une case remplie
        if (row[j] !== 'x') {
          // checking de la ligne
          // on parcours de nouveau la ligne
          for (let k = 0; k < row.length; k++) {
            // si la case est différente que celle que l'on a trouvé
            if (k !== j) {
              // on stocke la case
              const tetrisTile = tetrisGrid[i][k]
              // si la case remplie trouvée est égale au type de la mem
              if (row[j] === tetrisTile.type1) {
                // on lui assigne le type2 et indique une nouvelle pièce placée
                row[k] = tetrisTile.type2
                // on regarde si il y a un row au dessus et si l'id de de la case du dessus = celui de la case
                if (tetrisGrid[i - 1] && tetrisGrid[i - 1][k].id === tetrisTile.id) {
                  resolvedGrid[i - 1][k] = tetrisTile.type1
                } else if (tetrisGrid[i + 1] && tetrisGrid[i + 1][k].id === tetrisTile.id) {
                  resolvedGrid[i + 1][k] = tetrisTile.type1
                }
              } else if (row[j] === tetrisTile.type2) {
                // on lui assigne le type2 et indique une nouvelle pièce placée
                row[k] = tetrisTile.type1
                // on regarde si il y a un row au dessus et si l'id de de la case du dessus = celui de la case
                if (tetrisGrid[i - 1] && tetrisGrid[i - 1][k].id === tetrisTile.id) {
                  resolvedGrid[i - 1][k] = tetrisTile.type2
                } else if (tetrisGrid[i + 1] && tetrisGrid[i + 1][k].id === tetrisTile.id) {
                  resolvedGrid[i + 1][k] = tetrisTile.type2
                }
              }
            }
          }

          // checking de la colonne
          // on parcours la collone
          for (let l = 0; l < resolvedGrid.length; l++) {
            if (l !== i) {
              const tetrisTile = tetrisGrid[l][j]

              if (row[j] === tetrisTile.type1) {
                // on lui assigne le type2 et indique une nouvelle pièce placée
                resolvedGrid[l][j] = tetrisTile.type2
                if (tetrisGrid[l][j - 1] && tetrisGrid[l][j - 1].id === tetrisTile.id) {
                  resolvedGrid[l][j - 1] = tetrisTile.type1
                } else if (tetrisGrid[l][j + 1] && tetrisGrid[l][j + 1].id === tetrisTile.id) {
                  resolvedGrid[l][j + 1] = tetrisTile.type1
                }
              } else if (row[j] === tetrisTile.type2) {
                // on lui assigne le type2 et indique une nouvelle pièce placée
                resolvedGrid[l][j] = tetrisTile.type1
                // on regarde si il y a un row au dessus et si l'id de de la case du dessus = celui de la case
                if (tetrisGrid[l][j - 1] && tetrisGrid[l][j - 1].id === tetrisTile.id) {
                  resolvedGrid[l][j - 1] = tetrisTile.type2
                } else if (tetrisGrid[l][j + 1] && tetrisGrid[l][j + 1].id === tetrisTile.id) {
                  resolvedGrid[l][j + 1] = tetrisTile.type2
                }
              }
            }
          }
        }
      }
    }
    ++tries
  }
  return !resolvedGrid.flat().some(item => item === 'x')
}

function getAvailableIndexes (grid) {
  const availableIndexes = []
  for (let i = 0; i < grid.length; i++) {
    for (let j = 0; j < grid[i].length; j++) {
      if (grid[i][j] === 'x') availableIndexes.push([i, j])
    }
  }
  return availableIndexes
}

export {
  generateGrid,
  generateEmptyGrid,
  checkNeighbourIndex,
  resolveGrid,
  getAvailableIndexes
}
